import { clsx } from 'clsx';

import { useDataTable } from '../../../contexts/DataTableContext.js';
import type { DataTableExpandableRowWrapperProps } from '../row-details-types.js';
import * as styles from '../RowDetails.sty.js';

/**
 * Wrapper helper for the DataTable.ExpandableRow that will automatically sync
 * specific style properties like row padding for rowDensity variant settings.
 *
 * Sets `role="cell"` on its root element to satisfy ARIA grid semantics
 * inside the expandable row's `role="row"` container.
 * @public
 */
export function DataTableExpandableRowWrapper(
  props: Readonly<DataTableExpandableRowWrapperProps>,
) {
  const {
    className: consumerClassName,
    'data-testid': dataTestId,
    style: consumerStyle,
    ...remainingProps
  } = props;
  const table = useDataTable();
  return (
    <div
      data-testid={dataTestId}
      {...remainingProps}
      role="cell"
      className={clsx(
        consumerClassName,
        styles.rowDetailsWrapper({
          rowDensity: table.atoms.visualVariantConfig?.get().rowDensity,
        }),
      )}
      style={consumerStyle}
    />
  );
}
